import React from 'react';
import { FormSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { usePeopleFinderProjectFilter, PEOPLE_FINDER_PROJECT_OPTIONS } from './usePeopleFinderProjectFilter';

export const PeopleFinderProjectFilter = ({ value, setFilters }) => {
  const { formSchema, onSubmit } = usePeopleFinderProjectFilter({ setFilters });

  const selectedOption =
    PEOPLE_FINDER_PROJECT_OPTIONS.find((i) => i.value === value) ?? PEOPLE_FINDER_PROJECT_OPTIONS[0];

  return (
    <Formik
      initialValues={{ hasPeopleFinderProject: selectedOption || '' }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="hasPeopleFinderProject"
          label="People Finder project"
          placeholder="Any"
          size="small"
          component={FormSelect}
          options={PEOPLE_FINDER_PROJECT_OPTIONS}
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

PeopleFinderProjectFilter.propTypes = {
  value: PropTypes.string,
  setFilters: PropTypes.func.isRequired,
};

PeopleFinderProjectFilter.defaultProps = {
  value: 'any',
};
